<script setup lang="ts">
const props = withDefaults(defineProps<{ filled?: boolean; size?: string; color?: string }>(), {
  filled: false,
  size: undefined,
  color: undefined,
});
</script>

<template>
  <svg
    v-if="filled"
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M3 12a2 2 0 1 1 0 4H2v1.5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5H3Zm-1 3h1a1 1 0 1 0 0-2H2v2Zm6-3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6.5a.5.5 0 0 1-.5-.5v-5c0-.28.22-.5.5-.5H8Zm-1 5h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H7v4Zm7.1-4.99a.5.5 0 0 1 0 .98L14 13h-2v1.5h1.5a.5.5 0 0 1 0 1H12v2a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5H14l.1.01ZM10 6.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5h-1.59c.06-.16.09-.32.09-.5v-1h.5a1.5 1.5 0 0 0 1.02-2.6A1.5 1.5 0 0 0 14 11h-2.5a1.5 1.5 0 0 0-1.37.89A2.99 2.99 0 0 0 8 11H6.5a1.5 1.5 0 0 0-1.32.8A2.75 2.75 0 0 0 4 11.1V3.5C4 2.67 4.67 2 5.5 2H10v4.5Zm5.75.5H11.5a.5.5 0 0 1-.5-.5V2.25L15.75 7Z"
    />
  </svg>
  <svg
    v-else
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M3 12a2 2 0 1 1 0 4H2v1.5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5H3Zm-1 3h1a1 1 0 1 0 0-2H2v2Zm6-3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6.5a.5.5 0 0 1-.5-.5v-5c0-.28.22-.5.5-.5H8Zm-1 5h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H7v4Zm7.1-4.99a.5.5 0 0 1 0 .98L14 13h-2v1.5h1.5a.5.5 0 0 1 0 1H12v2a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5H14l.1.01ZM10.6 2c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V16a2 2 0 0 1-2 2h-1.09c.06-.16.09-.32.09-.5V17h1a1 1 0 0 0 1-1v-2.39a1.49 1.49 0 0 0 0-2.23V8h-3.5A1.5 1.5 0 0 1 10 6.5V3H6a1 1 0 0 0-1 1v7.63a2.74 2.74 0 0 0-1-.52V4c0-1.1.9-2 2-2h4.59ZM11 6.5c0 .28.22.5.5.5h3.3L11 3.2v3.3Z"
    />
  </svg>
</template>
